import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import PropTypes from 'prop-types'

/* Utils */
import {renderComponentsSwitch} from '../../utils/contentRenderer'
import {generateStyles, getHideStyles} from '../../utils/utils'

const TitleDescriptionBlock = ({
    Title,
    Description,
    Cta,
    TitleDescriptionBlockTitleStyle,
    TitleDescriptionBlockDescriptionStyle,
    HideOnDevices,
    ...props
}) => {
    const hideStyles = getHideStyles(HideOnDevices)

    if (hideStyles.doNotLoadComponent) return null

    return (
        <Box data-block-type="TitleDescriptionBlock" {...hideStyles}>
            {Title && (
                <Text
                    {...generateStyles(TitleDescriptionBlockTitleStyle, {
                        marginBottom: Description || Cta ? '16px' : 0
                    })}
                    as={TitleDescriptionBlockTitleStyle?.TagType || 'h2'}
                >
                    {Title}
                </Text>
            )}
            {Description && (
                <Text
                    {...generateStyles(TitleDescriptionBlockDescriptionStyle, {
                        marginBottom: Cta ? '24px' : 0
                    })}
                >
                    {Description}
                </Text>
            )}
            {Cta?.Expanded && renderComponentsSwitch(Cta.Expanded, props)}
        </Box>
    )
}

TitleDescriptionBlock.propTypes = {
    Title: PropTypes.string,
    Description: PropTypes.string,
    Cta: PropTypes.shape({
        Expanded: PropTypes.object
    }),
    TitleDescriptionBlockTitleStyle: PropTypes.object,
    TitleDescriptionBlockDescriptionStyle: PropTypes.object,
    HideOnDevices: PropTypes.string
}

export default TitleDescriptionBlock
